import React from 'react';
import { useViewerCount } from '../hooks/useViewerCount';
type ViewerCounterProps = {
  className?: string;
};
export function ViewerCounter({
  className = ''
}: ViewerCounterProps) {
  const count = useViewerCount();
  return <div className={`flex items-center justify-center gap-2 rounded-full border border-line bg-sage/60 px-4 py-2.5 ${className}`} aria-live="polite" data-id="element-159" data-mp="35x31vrtkna9z">
      <span aria-hidden="true" className="h-2 w-2 shrink-0 rounded-full bg-[#4B7A58]" data-id="element-160" data-mp="2d9qejffl6yfm" />
      <p className="font-sans text-[14px] font-medium text-[#3F6349]" data-id="element-161" data-mp="2d7dv0xu6kg0g">
        {count} personas viendo esto ahora
      </p>
    </div>;
}